
import { Question, QuestionContent as QuestionContentType, isQuestionContent } from "@/types/test";
import { Textarea } from "@/components/ui/textarea";
import { AlertCircle, CheckCircle2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { CodingQuestionEditor } from "./CodingQuestionEditor";
import { CodingQuestionView } from "./CodingQuestionView";

interface QuestionContentProps {
  content: Question["content"];
  onUpdate: (content: Question["content"]) => void;
  question?: Question;
  isEditing?: boolean;
  onQuestionUpdate?: (id: string, updates: Partial<Question>) => void;
}

export const QuestionContent = ({ content, onUpdate, question, isEditing = true, onQuestionUpdate }: QuestionContentProps) => {
  const questionContent = isQuestionContent(content) ? content : { question: '' };
  const isEmpty = !questionContent.question?.trim();

  // Handle coding questions
  if (question?.question_type === 'coding') {
    if (isEditing) {
      return (
        <CodingQuestionEditor
          question={question}
          onUpdate={onQuestionUpdate || ((id, updates) => {
            // Fallback for when onQuestionUpdate is not provided
            if (updates.content) {
              onUpdate(updates.content);
            }
          })}
        />
      );
    } else {
      return <CodingQuestionView question={question} />;
    }
  }

  // Default question content for non-coding questions
  return (
    <div>
      <Textarea
        value={questionContent.question || ''}
        onChange={(e) =>
          onUpdate({
            ...questionContent,
            question: e.target.value,
          })
        }
        placeholder="Enter your question here..."
        className="min-h-[120px] resize-y bg-transparent text-xl leading-relaxed"
        rows={6}
      />
    </div>
  );
};
